import { render, staticRenderFns } from "./ButtonElement.vue?vue&type=template&id=34fb09ce&"
import script from "./ButtonElement.vue?vue&type=script&lang=ts&"
export * from "./ButtonElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports